import { ClientError } from 'graphql-request';
import { z } from 'zod';

// Only fixed, typed diagnostics may cross the telemetry boundary. Never reuse the
// ClientError: its message and stack contain the request and upstream response.
const httpStatusSchema = z.number().int().min(100).max(599);
const graphqlErrorsSchema = z.array(z.unknown()).catch([]);
const graphqlErrorSchema = z.object({
  extensions: z.object({
    code: z.enum([
      'BAD_USER_INPUT',
      'FORBIDDEN',
      'RATE_LIMITED',
      'UNAUTHENTICATED',
      'UPSTREAM_SERVICE_ERROR',
    ]),
  }),
});

export const redactGraphqlRequestErrorForTelemetry = (error: unknown): unknown => {
  if (!(error instanceof ClientError)) return error;

  const errors = graphqlErrorsSchema.parse(error.response.errors);
  const prefix = errors.length ? 'GraphQL request failed' : 'Network request failed';
  const status = httpStatusSchema.safeParse(error.response.status);
  const codes = [
    ...new Set(
      errors.flatMap((item) => {
        const parsed = graphqlErrorSchema.safeParse(item);
        return parsed.success ? [parsed.data.extensions.code] : [];
      }),
    ),
  ].sort();
  const diagnostics = [
    ...(status.success ? [`HTTP ${status.data}`] : []),
    ...(codes.length ? [`codes: ${codes.join(', ')}`] : []),
  ];
  return new Error(diagnostics.length ? `${prefix} (${diagnostics.join('; ')})` : prefix);
};
